import { ThemeProvider } from '@mui/material/styles';
import { getTheme } from '@parsys/frontend_library';
import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import Calendar from './Calendar';
import './index.css';
import ErrorFallback from 'FRONTEND/components/ErrorFallback';
import { mounted, unmounted } from 'FRONTEND/reducers/calendarSlice';
import { THEME_APP_NAME } from 'FRONTEND/utils/constants';

export default (element, store) => {
  store.dispatch(mounted());

  const root = createRoot(element);
  const theme = getTheme({ app: THEME_APP_NAME, branding: window.branding });
  root.render(
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <Calendar
            rtcServerUrl={element.dataset.rtcServerUrl}
          />
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>,
  );

  return () => {
    store.dispatch(unmounted());
    root.unmount();
  };
};
